module.exports = __webpack_public_path__ + "static/media/1015.debb201d.jpg";